// extracted by mini-css-extract-plugin
export var billingAddress = "_qs-g";
export var contactInfo = "_qs-d";
export var customerInfoContainer = "_qs-c";
export var customerInfoContainerMobile = "_qs-h";
export var customerInfoRow = "_qs-a";
export var customerInfoSection = "_qs-b";
export var fullWidthDividerMobile = "_qs-i";
export var imageContainer = "_qs-1";
export var paymentMethod = "_qs-e";
export var priceText = "_qs-6";
export var priceTextMobile = "_qs-7";
export var product = "_qs-0";
export var productImage = "_qs-2";
export var productInfo = "_qs-4";
export var productMobile = "_qs-9";
export var productTitle = "_qs-8";
export var quantityBadge = "_qs-3";
export var quantityText = "_qs-5";
export var shippingAddress = "_qs-f";